import sessionId from 'Helpers/sessionId'

function getStorageKey (key, prefix = sessionId) {
  return `${prefix ? prefix + '-' : ''}${key}`
}

export const storeSet = (key, value, prefix) => {
  return window.localStorage.setItem(
    getStorageKey(key, prefix),
    JSON.stringify(value)
  )
}

export const storeGet = (key, prefix) => {
  return JSON.parse(window.localStorage.getItem(getStorageKey(key, prefix)))
}

export const storeRemove = (key, prefix) => {
  return window.localStorage.removeItem(getStorageKey(key, prefix))
}
